import * as BABYLON from '@babylonjs/core';

export default function modelMeshesFor(scene: BABYLON.Scene) {
  const prefixes = ["union", "model", "basePlate"];
  return scene.meshes.filter(ea => prefixes.some(pre => ea.id.startsWith(pre)));
}